import React from 'react';

export default class OrgUserCourseResults extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            courseName: "",
            results: [],
            notAttempted: []
        }
    }
    componentDidMount()
    {
        this.loadresults();
    }
    loadresults()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Course",
            action: "LoadOrgCourseResultList",
            method: "post",
            body: JSON.stringify({
                courseID: this.props.id
            }),
            success: result => {
                this.setState({
                    loaded: true,
                    results: result.results,
                    courseName: result.courseName,
                    notAttempted: result.notAttempted
                }, () => console.log(result))
            },
            error: err => {
                this.setState({loaded: true});
            }
        })
    }
    render()
    {
        const userAttemptInfo = []
        this.state.results.forEach(result => {
            const passed = Math.round((result.correctAnswers / (result.correctAnswers + result.incorrectAnswers)) * 100) >= result.passingPercent
            const usr = userAttemptInfo.filter(user => 
                user.username === result.username
            );
            if (usr.length === 0)
            {
                userAttemptInfo.push({
                    username: result.username, 
                    attempts: [result.attemptID], 
                    passed: passed
                })
            }
            else
            {
                const findattempt = usr[0].attempts.filter(attempt => attempt === result.attemptID);
                if (findattempt.length === 0)
                {
                    usr[0].attempts.push(result.attemptID);
                }
                if (passed)
                    usr[0].passed = true;
            }
        })
        return (
            <div className="lmsdisplayarea">
                <h3>
                    User Results {this.state.courseName !== "" ? "for " + this.state.courseName : null}
                </h3>
                {this.state.loaded ? (
                    <div>
                        <h4>User Attempts</h4>
                        <table className="lmstable" style={{marginTop: "12px"}}>
                            <tbody>
                                <tr>
                                    <th>Username</th>
                                    <th>Passed</th>
                                    <th>Attempts</th>
                                </tr>
                                {userAttemptInfo.length === 0 ? (
                                    <tr colSpan="3">
                                        <td><i>No user attempt data available.</i></td>
                                    </tr>
                                ) : null}
                                {userAttemptInfo.map(userinfo => 
                                    <tr key={userinfo.username}>
                                        <td>{userinfo.username}</td>
                                        <td>{userinfo.passed ? "Yes" : "No"}</td>
                                        <td>{userinfo.attempts.length}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <h4>Not Attempted</h4>
                        <table className="lmstable" style={{marginTop: "12px"}}>
                            <tbody>
                                <tr>
                                    <th>Username</th>
                                </tr>
                                {this.state.notAttempted.length === 0 ? (
                                    <tr>
                                        <td><i>No data found.</i></td>
                                    </tr>
                                ) : null}
                                {this.state.notAttempted.map(userinfo =>
                                    <tr key={userinfo.userID}>
                                        <td>{userinfo.username}</td>
                                    </tr>    
                                )}
                            </tbody>
                        </table>
                        <h4>Attempt Details</h4>
                        <table className="lmstable" style={{marginTop: "12px"}}>
                        <tbody>
                            <tr>
                                <th>Username</th>
                                <th>Pretest</th>
                                <th>Correct Answers</th>
                                <th>Incorrect Answers</th>
                                <th>Score</th>
                                <th>Pass / Fail</th>
                            </tr>
                            {this.state.results.length === 0 ? (
                                <tr>
                                    <td colSpan="6">
                                        <i>No course attempts have been made.</i>
                                    </td>
                                </tr>
                            ) : null}
                            {this.state.results.map(result => 
                                <tr key={result.testID}>
                                    <td>{result.username}</td>
                                    <td>{result.pretest ? "Yes" : "No"}</td>
                                    <td>{result.correctAnswers}</td>
                                    <td>{result.incorrectAnswers}</td>
                                    <td>
                                        {Math.round((result.correctAnswers / (result.correctAnswers + result.incorrectAnswers)) * 100)}
                                    </td>
                                    <td>
                                        {Math.round((result.correctAnswers / (result.correctAnswers + result.incorrectAnswers)) * 100) >= result.passingPercent ? 
                                            "Pass" : "Fail"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>   
                    </div>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/organization/orgusercourseresults.js